import { useState, useEffect } from "react";
import { Slider, Box } from "@mui/material";

export default function Calculator() {
  const [dimensions, setDimensions] = useState({
    өргөн: 1,
    өндөр: 1,
    урт: 1,
  });

  const [price, setPrice] = useState(0);
  const UNIT_PRICE = 600; // Price per unit volume

  const handleChange = (key, value) => {
    setDimensions((prev) => ({
      ...prev,
      [key]: value,
    }));
  };

  useEffect(() => {
    const { өргөн, өндөр, урт } = dimensions;
    const volume = (өргөн * өндөр * урт); // Simplified cubic volume
    const estimatedPrice = volume * UNIT_PRICE;
    setPrice(estimatedPrice);
  }, [dimensions]);

  return (
    <div className="p-8 border-2 mt-[50px] rounded-lg shadow-lg max-w-lg mx-auto bg-gray-100">
      <h2 className="text-3xl font-serif text-gray-800 text-center mb-6">
        Тооцоолуур
      </h2>

      {Object.entries(dimensions).map(([key, value]) => (
        <div key={key} className="mt-6">
          <div className="flex justify-between items-center">
            <Box className="w-[85px]">
              <span className="text-lg font-medium text-gray-700">
                {key === "өргөн" ? "Өргөн" : key === "өндөр" ? "Өндөр" : "Урт"}:
              </span>
            </Box>
            <Slider
              value={value}
              onChange={(_, newValue) => handleChange(key, newValue)}
              min={1}
              max={1000}
              sx={{
                width: "75%",
                color: "#6b8e23",
                height: 8,
                "& .MuiSlider-thumb": {
                  backgroundColor: "#6b8e23",
                },
              }}
            />
            <Box className="w-[70px] ml-[20px]">
              <p className="font-semibold text-gray-700 text-[15px]">
                {value} см
              </p>
            </Box>
          </div>
        </div>
      ))}

      {price > 0 && (
        <div className="mt-6 text-xl font-semibold text-center">
          Нийт үнэ: <span className="text-green-600">{price} ¥</span>
        </div>
      )}
    </div>
  );
}
